import { Component } from '@angular/core';
import { NavigationEnd, NavigationError, Router } from '@angular/router';
import { clearChunkLoadReloadGuard, recoverFromChunkLoadError } from 'app/chunk-load-recovery';
import { ConfigService } from 'app/config.service';
import { UserService } from 'app/private/_core/_services/user.service';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {

	constructor(
		private router: Router,
		private configService: ConfigService,
		private userService: UserService,
	) {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationError) {
				recoverFromChunkLoadError(event.error, event.url);
			} else if (event instanceof NavigationEnd) {
				clearChunkLoadReloadGuard();
			}
		});

		// check url for login helper queryParams
		this.configService.branch_badgeid =
			this.getParameterByName('badgeid') || '';
		if (this.configService.branch_badgeid)
			this.configService.branch_badgeid = this.configService.branch_badgeid
				.split(' ')
				.join('')
				.trim();
		this.configService.branch_email = this.getParameterByName('email') || '';
		this.configService.branch_auto = this.getParameterByName('auto') || '';
		this.configService.logInUtmCampaign = this.getParameterByName('utm_campaign') || '';

		// If non-widget session and reg id is present in url
		// we will see if we should redirect to login and pre-fill details (email may also be present)
		if (
			window.location.hostname !== environment.publicDomain &&
			this.configService.branch_badgeid.length !== 0
		) {
			// Check if user is logged in as user that matches the badge id in the URL (if so - do not redirect to login)
			if (this.userService.isLoggedIn()) {
				if (this.userService.user?.registration_id !== this.configService.branch_badgeid) {
					this.userService.logout();
					this.goToLogin();
					return;
				}
			} else {
				this.goToLogin();
				return;
			}
		}
	}

	private getParameterByName(name: string): string {
		const url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/%20/g, '+'));
	}

	private goToLogin(): void {
		if (
			this.configService.sso === 0 &&
			this.configService.loginVersion === 2
		) {
			this.router.navigate([this.configService.configName + '/event-login']);
		} else {
			this.router.navigate([this.configService.configName + '/login']);
		}
	}
}